<template>
  <div class="d-flex justify-center actions-bar">
    <NewRoleTemplateDialog
      @close="closeDialog"
      @created="$emit('created')"
      :isOpen="isOpen"
    />
    <SecondaryButton
      @click.native="openDialog"
      permission="create"
      color="primary"
    >
      <div class="d-flex align-center justify-center mb-1">
        <svg
          class="job-icon"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            class="fill"
            d="M12 4.21053V2.10526H8V4.21053H12ZM2 6.31579V17.8947H18V6.31579H2ZM18 4.21053C19.11 4.21053 20 5.14737 20 6.31579V17.8947C20 19.0632 19.11 20 18 20H2C0.89 20 0 19.0632 0 17.8947L0.00999999 6.31579C0.00999999 5.14737 0.89 4.21053 2 4.21053H6V2.10526C6 0.936842 6.89 0 8 0H12C13.11 0 14 0.936842 14 2.10526V4.21053H18Z"
          />
        </svg>
        <v-icon small>mdi-plus</v-icon>
      </div>
      New Role Template
    </SecondaryButton>
  </div>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import NewRoleTemplateDialog from "@/views/settings/components/role-templates/components/dialogs/NewRoleTemplateDialog";

export default {
  components: {
    NewRoleTemplateDialog,
    SecondaryButton
  },
  data() {
    return {
      isOpen: false,
      contractType: null
    };
  },
  methods: {
    onSelectJobType(contractType) {
      this.contractType = contractType;
    },
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
<style lang="scss"></style>
